import { AuthUserSchema } from "@/features/auth/auth.types";
import { z } from "zod";

export const ForgotPasswordRequestSchema = z.object({
	email: z.string().email(),
});

export const ForgotPasswordResponseSchema = z.object({
	success: z.boolean(),
});

export const ResetPasswordRequestSchema = z.object({
	token: z.string(),
	password: z.string(),
});

export const ResetPasswordResponseSchema = z.object({
	success: z.boolean(),
});

export const ResetRequestSchema = z.object({
	email: z.string().email(),
	password: z.string(),
});

export const ResetRequestResponseSchema = z.object({
	success: z.boolean(),
});

export const ResetVerifySchema = z.object({
	email: z.string().email(),
	code: z.string(),
});

export const ResetVerifyResponseSchema = z.object({
	success: z.boolean(),
	accessToken: z.string().optional(),
	refreshToken: z.string().optional(),
	user: AuthUserSchema.optional(),
});

export type ForgotPasswordRequest = z.infer<typeof ForgotPasswordRequestSchema>;
export type ForgotPasswordResponse = z.infer<typeof ForgotPasswordResponseSchema>;
export type ResetPasswordRequest = z.infer<typeof ResetPasswordRequestSchema>;
export type ResetPasswordResponse = z.infer<typeof ResetPasswordResponseSchema>;
export type ResetRequest = z.infer<typeof ResetRequestSchema>;
export type ResetRequestResponse = z.infer<typeof ResetRequestResponseSchema>;
export type ResetVerify = z.infer<typeof ResetVerifySchema>;
export type ResetVerifyResponse = z.infer<typeof ResetVerifyResponseSchema>;
